import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { fetchNotifications, NotificationProps } from "./notificationActions";

interface NotificationState {
    list: NotificationProps[];
}

const initialState: NotificationState = {
    list: [],
};

const notificationSlice = createSlice({
    name: "notifications",
    initialState,
    reducers: {
        addNotification(state, action: PayloadAction<NotificationProps>) {
            state.list.unshift(action.payload);
        },
        readNotifications(state, action: PayloadAction<string>) {
            const notif = state.list.find((n) => n.id === action.payload);
            if (notif) notif.read = true;
        },
        setNotifications(state, action: PayloadAction<NotificationProps[]>) {
            state.list = action.payload
                .slice()
                .sort(
                    (a, b) =>
                        new Date(b.createdAt).getTime() -
                        new Date(a.createdAt).getTime()
                );
        },
    },
    extraReducers: (builder) => {
        builder.addCase(fetchNotifications.fulfilled, (state, action) => {
            const page = action.meta.arg.page;

            if (page === 1) {
                state.list = action.payload
                    .slice()
                    .sort(
                        (a, b) =>
                            new Date(b.createdAt).getTime() -
                            new Date(a.createdAt).getTime()
                    );
            } else {
                const existingIds = new Set(state.list.map((n) => n.id));
                const newNotifications = action.payload.filter(
                    (n) => !existingIds.has(n.id)
                );

                state.list = [...state.list, ...newNotifications].sort(
                    (a, b) =>
                        new Date(b.createdAt).getTime() -
                        new Date(a.createdAt).getTime()
                );
            }
        });
    },
});

export const { addNotification, readNotifications, setNotifications } =
    notificationSlice.actions;

export default notificationSlice.reducer;
